module.exports = __webpack_public_path__ + "static/media/cc.94b80cc1.png";